// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2q5nM","boxTitle":"Qualiphy_boxTitle__1aXTW","box":"Qualiphy_box__3Xqs0","toggleWrap":"Qualiphy_toggleWrap__2NY59"};